import { DeviceType } from 'sofa-reborn-react';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import styled from 'styled-components';

function getOpacity(showRotationIcon: boolean): string {
	return showRotationIcon === false
		? `
				opacity: 0;
		  `
		: `
				opacity: 1;
		  `;
}

export const StyledRotationIcon = styled.div<{
	top: string;
	left: string;
	deviceType: DeviceType;
	showRotationIcon: boolean;
}>`
	display: ${(props) => (props.showRotationIcon ? 'flex' : 'none')};
	align-items: center;
	position: absolute;
	top: ${(props) => props.top};
	left: ${(props) => props.left};
	padding: ${(props) => (props.deviceType === 'mobile' ? '8px' : '16px')};
	color: ${SkapaTheme.color.neutral.grey500};
	background-color: ${SkapaTheme.color.neutral.white};
	border-radius: 40px;
	border-width: 0;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);

	${(props) => getOpacity(props.showRotationIcon)};
	transition: opacity 0.3s ease-in;
	${(props) => (props.deviceType === 'tablet' ? 'z-index: -1;' : null)}
`;
